<template>
  <div class="yearList">
    <div class="yearBanner">
      <div class="config">
        <router-link to="/" class="logo" target="_blank"
          ><img src="/static/year/Landingpage_MANA_head_logo@2x.png" alt=""
        /></router-link>

        <el-popover placement="bottom" width="240px" trigger="hover">
          <share :config="config"></share>
          <span class="configBox" slot="reference">
            <img src="/static/year/landingpage_share_icon@2x.png" alt="" /><span
              class="text"
              >{{ $t("global.分享") }}</span
            >
          </span>
        </el-popover>
      </div>
    </div>
    <div class="imgList">
      <div
        class="imgBox"
        v-for="(item, i) in imgList"
        :key="i"
        :style="{ backgroundImage: `url(${item.imgurl})` }"
        @mouseenter="index = i"
        @mouseleave="index = null"
        @click="goto(item.url)"
      >
        <div class="butBox" :class="{ active: index == i }">
          <img
            src="https://image.manamana.net/1672897938000_pphLkyTy"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Share from "@/components/v2/Share";
export default {
  name: "flowingLight",
  metaInfo() {
    return {
      title: "2023中国·重庆首届国际光影艺术节 | MANA",
    };
  },
  data() {
    return {
      config: {},
      index: null,
      imgList: [
        {
          imgurl: "https://image.manamana.net/1706511106000_ltZGAFGX",
          url: "/video/detail?id=2373548",
        },
        {
          imgurl: "https://image.manamana.net/1706511135000_TqfozPuW",
          url: "/video/detail?id=2374005",
        },
        {
          imgurl: "https://image.manamana.net/1706511147000_nqHOFoQS",
          url: "/video/detail?id=2374011",
        },
        {
          imgurl: "https://image.manamana.net/1706511163000_XmdBxZpf",
          url: "/video/detail?id=2374935",
        },
        {
          imgurl: "https://image.manamana.net/1706511179000_emnUVfbw",
          url: "/video/detail?id=2374506",
        },
        {
          imgurl: "https://image.manamana.net/1706511196000_bbAHpFCS",
          url: "/video/detail?id=2375217",
        },
        {
          imgurl: "https://image.manamana.net/1706511210000_sctOBDgl",
          url: "/video/detail?id=2375382",
        },
        {
          imgurl: "https://image.manamana.net/1706511223000_HfkkfSce",
          url: "/video/detail?id=2378848",
        },
        {
          imgurl: "https://image.manamana.net/1706511238000_Kptmqruh",
          url: "/video/detail?id=2378348",
        },
        
        {
          imgurl: "https://image.manamana.net/1706511260000_VVZBiupN",
          url: "/video/detail?id=2379038",
        },
        {
          imgurl: "https://image.manamana.net/1706511273000_gKWbHuNB",
          url: "/video/detail?id=2378811",
        },
        {
          imgurl: "https://image.manamana.net/1706511288000_iUOMundefinedEUO",
          url: "/video/detail?id=2378788",
        },
        {
          imgurl: "https://image.manamana.net/1706511302000_WdhiAGTq",
          url: "/video/detail?id=2379274",
        },
        {
          imgurl: "https://image.manamana.net/1706511314000_rSRqgQxM",
          url: "/video/detail?id=2378684",
        },
        {
          imgurl: "https://image.manamana.net/1706511324000_PilVopEt",
          url: "/video/detail?id=2378735",
        },
        {
          imgurl: "https://image.manamana.net/1706511340000_xlEDWMlA",
          url: "/video/detail?id=2378772",
        },
        {
          imgurl: "https://image.manamana.net/1706511354000_uHUKwnGQ",
          url: "/video/detail?id=2379191",
        },
        {
          imgurl: "https://image.manamana.net/1706511370000_UundefinedYEEyig",
          url: "/video/detail?id=2378849",
        },
        {
          imgurl: "https://image.manamana.net/1706511381000_IRzqvynt",
          url: "/video/detail?id=2380379",
        },
        {
          imgurl: "https://image.manamana.net/1706511395000_rMGmweVW",
          url: "/video/detail?id=2379119",
        },
        {
          imgurl: "https://image.manamana.net/1706511409000_ftbqCdyt",
          url: "/video/detail?id=2379334",
        },
        {
          imgurl: "https://image.manamana.net/1706511421000_zzdLTRmd",
          url: "/video/detail?id=2378280",
        },
        {
          imgurl: "https://image.manamana.net/1706511434000_zrvXiDGD",
          url: "/video/detail?id=2379198",
        },
        {
          imgurl: "https://image.manamana.net/1706511447000_cfsXEppC",
          url: "/video/detail?id=2378773",
        },
        {
          imgurl: "https://image.manamana.net/1706511459000_GUlhrLNk",
          url: "/video/detail?id=2378910",
        },
      ],
    };
  },
  created() {
    this.config = {
      share_url: location.href,
      title: '2023中国·重庆首届国际光影艺术节入围奖作品合辑',
      desc: "艺术让生活更美好",
      pics: "https://image.manamana.net/1672802500000_kUrXlBEw",
    };
  },
  components: {
    Share,
  },
  methods: {
    goto(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="stylus" scoped>
.yearList {
  background: url('https://image.manamana.net/1641535210000_gNSARNfQ');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-width: 918px;
  min-height: 100vh;
  .yearBanner {
    background: url('https://image.manamana.net/1706517373000_VzrzuSgk');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-position-x: center;
    height: 350px;

    .config {
      padding: 10px 30px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .logo {
        display: inline-block;
        width: 120px;
        height: 50px;
        vertical-align: middle;
        margin-right: 28px;
        cursor: pointer;

        img {
          width: 120px;
          height: 50px;
        }
      }

      .configBox {
        display: inline-block;
        vertical-align: middle;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        cursor: pointer;

        img {
          width: 40px;
          height: 40px;
        }

        .text {
          vertical-align: middle;
          margin-left: 4px;
        }
      }
    }
  }

  .imgList {
    width: 918px;
    margin: 0 auto;
    padding: 40px 0 120px 0;

    .imgBox {
      width: 100%;
      height: 194px;
      margin-bottom: 40px;
      background-size: 100%;
      position: relative;
      cursor: pointer;
      .butBox {
        height: 194px;
        width: 100%;
        line-height: 194px;
        text-align: center;
        img {
          display: none;
        }
      }

      .active {
        color: #FFFFFF;
        background: rgba(0, 0, 0, 0.5);
        img {
          display: inline-block;
          width: 44x;
          height: 44px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/yearList/CQILAC2023.vue